import React, { CSSProperties, FormEvent, useState } from "react";
import { Button, Fieldset, Input } from "shared/ui";
import { api } from "shared/api";

export interface IProfileNameForm {
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const ProfileNameForm = (props: IProfileNameForm) => {
  const profile = api.userProfile.useUserProfileMe();

  const [value, setValue] = useState<string>();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!profile.data || !value) return;
    await api.userProfile.userProfileUpdate({ name: value, avatarImageId: profile.data.avatarImage?.id || null });
    await profile.mutate();
    setValue(undefined);
  };

  return (
    <form className={props.className} style={props.style} id={props.htmlId} onSubmit={onSubmit}>
      <Fieldset>
        <Fieldset.Content>
          <Fieldset.Title>Имя, Фамилия</Fieldset.Title>
          <Fieldset.Subtitle>
            Укажите ваше имя и фамилию. Они будут видны другим сотрудникам вашей компании.
          </Fieldset.Subtitle>
          <Input
            style={{ maxWidth: 300 }}
            name="name"
            value={value ?? profile.data?.name}
            placeholder={profile.data?.name === "" ? profile.data.email : undefined}
            onChange={(e) => setValue(e.target.value)}
          />
        </Fieldset.Content>
        <Fieldset.Footer>
          <Fieldset.Footer.Status>Максимум 32 символа</Fieldset.Footer.Status>
          <Fieldset.Footer.Actions>
            <Button htmlType="submit" size="small" disabled={!value}>
              Сохранить
            </Button>
          </Fieldset.Footer.Actions>
        </Fieldset.Footer>
      </Fieldset>
    </form>
  );
};

ProfileNameForm.defaultProps = {};
